import { jwtDecode } from "jwt-decode";

// Function to check if the access token is expired
export default function isTokenExpired(token) {
  if (!token) return true; // If no token, treat as expired

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000; // current time in seconds
    return decoded.exp < currentTime; // compare expiration time with current time
  } catch (error) {
    return true; // If there's an error in decoding, consider the token expired
  }
}